"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pipe = /** @class */ (function () {
    function Pipe(logger) {
        this.logger = logger;
        this.promise = Promise.resolve();
    }
    Pipe.prototype.attach = function (work) {
        this.promise = this.promise.then(work);
        return this.promise;
    };
    Pipe.prototype.recover = function () {
        var _this = this;
        this.promise = this.promise.catch(function (error) {
            var _a, _b;
            if (((_a = _this.logger) === null || _a === void 0 ? void 0 : _a.isDebugEnabled()) === true) {
                (_b = _this.logger) === null || _b === void 0 ? void 0 : _b.debug("Recovering from ".concat(error));
            }
        });
    };
    return Pipe;
}());
exports.default = Pipe;
